var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthLeftBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 685,
    height: 345,
    viewBox: "0 0 685 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.97219 106.041L679.165 0.869143L682.339 103.039L-1.79824 208.211L-4.97219 106.041Z",
    fill: "#FAB54E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-227.255 242.558L440.628 137.891L443.802 240.06L-224.081 344.727L-227.255 242.558Z",
    fill: "#1467B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLeftBg);
export default __webpack_public_path__ + "static/media/AuthLeftBg.5a8c533ebfc5af130fbf87d0d12cbc0b.svg";
export { ForwardRef as ReactComponent };